import React, { useEffect, useState } from 'react';
import { NavLink as Link } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  Chip,
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import Page from '../../components/Page';
import useSettings from '../../hooks/useSettings';
import Title from '../../components/_dashboard/paquetes/Title';
import SimpleTable from '../../components/_dashboard/paquetes/SimpleTable';
import ReciboEnvio from '../../components/_dashboard/paquetes/ReciboEnvio';
import { Icon } from '@iconify/react';
import { firestore, analytics } from '../../contexts/FirebaseContext';
import { useLocation, useParams } from 'react-router';
// import { setEnvioDetalle } from '../../redux/slices/dagpacket';
import { useDispatch, useSelector } from 'react-redux';
// import { getTracking } from '../../_apis_/backend';
import {
  getGuia,
  getPDFRedpackUrl,
  getUpdatedEnvio,
  getOriginDestination,
  getGuiaUPS,
  getGuiaSuperenvios,
  getGuiaPdfSuperenvios,
  getGuiaMienvio,
  getGuia99Superenvios,
  getGuiaPaqueteXpress,
  getGuiaDHL,
  getGuiaFedex,
  getGuiaAltospack,
  getGuiaVencedor,
  getGuiaJyT,
  getGuiaEstafeta
} from '../../_apis_/dagpacket';
import { Map } from '../../components/maps';
import { fDirection } from '../../utils/formatDirection';
import PropTypes from 'prop-types';
import { BlobProvider, PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { fCurrency } from '../../utils/formatNumber';
import PaqueteriaCard from '../../components/_dashboard/paquetes/general/PaqueteriaCard';
import DialogFacturar from '../../components/_dashboard/paquetes/envioDetalle/DialogFacturar';
import DialogSolCancelarEnv from '../../components/_dashboard/paquetes/envioDetalle/cancelar-envio/DialogSolCancelarEnv';
import AddToCartBtn from '../../components/_dashboard/paquetes/envioDetalle/devolver-carrito/AddToCartBtn';
import TablaRastreo from '../../components/_dashboard/paquetes/envioDetalle/rastreo/TablaRastreo';
import DetalletEnvio from '../../components/_dashboard/paquetes/envioDetalle/detalleEnvio/DetalletEnvio';
import BtnActualizarEnvio from '../../components/_dashboard/paquetes/envioDetalle/actualizarEnvio/BtnActualizarEnvio';
import useAuthUsers from '../../hooks/useAuthUsers';
import QrRastreoPaq from '../../components/_dashboard/paquetes/QrRastreoPaq';
import ReciboCotizacion from '../../components/_dashboard/paquetes/ReciboCotizacion';
import { analyticsEvents } from '../../constants/analyticsEvents';
import { contratosList } from '../../constants/contratos';
// import BtnImprimirGuia from '../../components/_dashboard/paquetes/envioDetalle/imprimirGuia/BtnImprimirGuia';

// eslint-disable-next-line
const DATA = { ancho: '15 cm', alto: '15 cm', largo: '10 cm', peso: '5 kg' };
// eslint-disable-next-line
const ARR_DATA = [
  { fecha: '2022/04/29', detalle: 'Entregado - culiacan, sinaloa', localizacion: 'CULIACAN, SINALOA' },
  { fecha: '2022/04/29', detalle: 'Entregado - culiacan, sinaloa', localizacion: 'CULIACAN, SINALOA' },
  { fecha: '2022/04/29', detalle: 'Entregado - culiacan, sinaloa', localizacion: 'CULIACAN, SINALOA' }
];

// function getQRCodeImageUrl() {
//   // Create the QR code using the ReactQRCode component
//   const qrCode = <QrRastreoPaq value="https://www.example.com" />;

//   // Get the canvas element containing the QR code
//   const canvas = document.querySelector('canvas');

//   return canvas;

//   // Get the URL of the QR code image
//   // const qrCodeImageUrl = canvas.toDataURL();

//   // return qrCodeImageUrl;
// }

function PaqDetalleEnvio() {
  const [urlGuia, setUrlGuia] = useState('');
  const [loadingGuia, setLoadingGuia] = useState(false);
  const [errorGuia, setErrorGuia] = useState(false);
  const { themeStretch } = useSettings();

  const dispatch = useDispatch();
  const [envioDetalle, setEnvioDetalle] = useState({});
  // const { envioDetalle } = useSelector((state) => state.dagpacket);
  const [eventos] = useState([]);
  // console.log('este es el que quiero', envioDetalle);
  const { search } = useLocation();
  const [origin, setOrigin] = useState({ lat: 0, lng: 0 });
  const [destination, setDestination] = useState({ lat: 0, lng: 0 });
  console.log(envioDetalle);
  // console.log('este es el estado url', urlGuia);
  const { currentUser } = useAuthUsers();

  // obtener el parametro id
  const queryParams = new URLSearchParams(search);
  const paramId = useParams()?.id;
  const paramIdAdm = queryParams.get('id');
  const id = paramId || paramIdAdm;

  const oneRequest = queryParams.get('oneRequest') !== 'undefined' ? queryParams.get('oneRequest') : null;
  // console.log('ver data', oneRequest);
  const provider = queryParams.get('provider')?.split('/');

  const tipoPaq = envioDetalle?.tipo_envio ? envioDetalle?.tipo_envio?.split('?')[0] : '';
  // ----------------------

  // console.log(getQRCodeImageUrl());

  const paqueteriaData = {
    rate_provider: envioDetalle?.rate_provider,
    amount: envioDetalle?.shippingValue,
    service: envioDetalle?.service || '-',
    trackingNumber: envioDetalle?.trackingNumber || null,
    purchase_id: envioDetalle?.purchase_id || null,
    dagpacketCode: envioDetalle?.object_id || null
  };

  const paquete_data = {
    ancho: `${envioDetalle?.width} Cm`,
    alto: `${envioDetalle?.height} Cm`,
    largo: `${envioDetalle?.length} Cm`,
    peso: `${envioDetalle?.weight} Kg`,
    pesoVol: `${
      envioDetalle?.pesoVolumetrico
        ? envioDetalle?.pesoVolumetrico
        : (envioDetalle?.width * envioDetalle?.height * envioDetalle?.length) / 5000
    } Kg`
  };

  // tipo === true  --> sobre caso contrario es paquete
  const tipo =
    envioDetalle?.width === 10 &&
    envioDetalle?.height === 1 &&
    envioDetalle?.length === 20 &&
    envioDetalle?.weight === 1;

  // ============= esto es onerequest
  // useEffect(() => {
  //   if (oneRequest) {
  //     const queryParams = new URLSearchParams(search);

  // }, [oneRequest, provider, search]);

  // =================

  useEffect(() => {
    if (!oneRequest) {
      firestore
        .collection('cotizaciones')
        .doc(id)
        .onSnapshot((doc) => {
          const obj = { ...doc.data(), id };
          // dispatch(setEnvioDetalle(obj));
          setEnvioDetalle(obj);

          if (provider[0] === 'mienvio' || provider[0] === 'MiEnvio') {
            setUrlGuia(doc.data().label?.label_url);
          }
          if (provider[0] === 'SuperEnvios') {
            // const pdf = getGuiaSuperenvios(doc.data()?.label?.idPedido);
            // setUrlGuia(pdf);

            // const trackinNum = getGuiaUPS(queryParams.get('codigo'));
            const rate_provider = queryParams.get('paqueteria');

            // ------------------no tocar XD ------------------------
            const resss = getGuiaPdfSuperenvios(rate_provider, doc.data()?.label?.idPedido);
            setUrlGuia(resss);

            console.log(resss);
          }
        });
    } else {
      firestore
        .collection('cotizaciones')
        .doc(id)
        .onSnapshot((doc) => {
          const obj = { ...doc.data(), id };
          // dispatch(setEnvioDetalle(obj));
          setEnvioDetalle(obj);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch, oneRequest]);

  // useEffect(() => {
  //   async function getCoords() {
  //     if (envioDetalle !== null) {
  //       const [origen, destino] = fDirection(envioDetalle);
  //       // console.log('origen', origen);
  //       // console.log('destino', destino);
  //       const { startLocation, endLocation } = await getOriginDestination(origen, destino);
  //       setOrigin(startLocation);
  //       setDestination(endLocation);
  //     }
  //   }
  //   getCoords();
  // }, [envioDetalle]);

  useEffect(() => {
    // const queryParams = new URLSearchParams(search);
    if (!oneRequest) {
      analytics.logEvent(analyticsEvents.package_detail_shipment, { id });

      if (provider[0] === 'mienvio' || provider[0] === 'MiEnvio') {
        // console.log('es mienvio');
        getUpdatedEnvio(id).then((res) => {
          // console.log('este es el update', res);
          firestore
            .collection('cotizaciones')
            .doc(id)
            .update({ ...res, created_at: new Date(res.created_at) });
        });
      }
    }
  }, [id, oneRequest, provider]);

  useEffect(() => {
    const queryParams = new URLSearchParams(search);
    if (!oneRequest) {
      if (provider[0] === 'UPS') {
        // console.log('esta llamando a ups');
        const pdf = getGuiaUPS(queryParams.get('codigo'));
        // const pdf = getGuiaUPS('1Z12345E8791315413');
        // console.log('es de ups', pdf);
        setUrlGuia(pdf);
        setLoadingGuia(false);
      }
      if (provider[0] === 'Redpack') {
        const pdf = getPDFRedpackUrl(queryParams.get('codigo'));
        setUrlGuia(pdf);
        setLoadingGuia(false);
      }
      if (provider[0] === 'mienvio' || provider[0] === 'MiEnvio') {
        // console.log('pedido mienvio');
      }
    } else {
      // ============= este es onerequest =============
      if (provider[0] === 'UPS') {
        const pdf = getGuiaUPS(queryParams.get('codigo'));
        // const pdf = getGuiaUPS('1Z12345E8791315413');
        // console.log('es de ups', pdf);
        setUrlGuia(pdf);
        setLoadingGuia(false);
      }
      if (provider[0] === 'Redpack') {
        const pdf = getPDFRedpackUrl(queryParams.get('codigo'));
        setUrlGuia(pdf);
        setLoadingGuia(false);
      }
      if (provider[0] === 'mienvio' || provider[0] === 'MiEnvio') {
        const pdf = getGuiaMienvio(queryParams.get('codigo'));
        // console.log('la url mienvio', pdf);
        setUrlGuia(pdf);
      }
      if (provider[0] === 'SuperEnvios') {
        const resss = getGuiaPdfSuperenvios(queryParams.get('paqueteria'), queryParams.get('codigo'));
        setUrlGuia(resss);
      }
      if (provider[0] === '99minutos') {
        const resss = getGuia99Superenvios(queryParams.get('codigo'));
        console.log('esto es 99', resss);
        setUrlGuia(resss);
      }
      if (provider[0] === 'PaqueteExpress') {
        const resss = getGuiaPaqueteXpress(queryParams.get('codigo'));
        // console.log('esto es paqexpress', resss);
        setUrlGuia(resss);
      }
      if (provider[0] === 'DHL') {
        const resss = getGuiaDHL(queryParams.get('codigo'));
        // console.log('esto es paqexpress', resss);
        setUrlGuia(resss);
      }
      if (provider[0] === 'Fedex') {
        const resss = getGuiaFedex(queryParams.get('codigo'));
        // console.log('esto es paqexpress', resss);
        setUrlGuia(resss);
      }
      if (provider[0] === 'Estafeta') {
        const resss = getGuiaEstafeta(queryParams.get('codigo'));
        // console.log('esto es paqexpress', resss);
        setUrlGuia(resss);
      }
      if (provider[0] === 'altospack') {
        // const resss = getGuiaAltospack(queryParams.get('codigo'));
        const resss = getGuiaAltospack(envioDetalle?.label_code);
        // console.log('esto es paqexpress', resss);
        setUrlGuia(resss);
      }
      if (provider[0] === 'vencedor') {
        // const resss = getGuiaAltospack(queryParams.get('codigo'));
        const resss = getGuiaVencedor(envioDetalle?.label_code);
        // console.log('esto es vencedor', resss);
        setUrlGuia(resss);
      }
      if (provider[0] === 'J') {
        // const resss = getGuiaAltospack(queryParams.get('codigo'));
        const resss = getGuiaJyT(envioDetalle?.label_code);
        // console.log('esto es jt', resss);
        setUrlGuia(resss);
      }
    }
  }, [search, id, provider, oneRequest, envioDetalle?.label_code]);

  return (
    <Page title="Detalle Envios">
      {paramId && (
        <Button variant="contained" component={Link} to="/dashboard/paquetes/envios">
          Volver
        </Button>
      )}
      {envioDetalle !== null && (
        <Container maxWidth={themeStretch ? false : 'lg'}>
          <Title title="Detalles del Envio" />
          <Box sx={{ margin: '10px 0' }}>
            <PaqueteriaCard item={paqueteriaData} pointer={0} />

            {/* codigo qr en display none porque solo quiero iobteber la url de la imagen para el recibo */}
            {envioDetalle.state === 'PAGADO' && (
              <Box sx={{ display: 'none' }}>
                <QrRastreoPaq value={`https://dagpacket-plataforma.web.app/rastreo/${id}`} idCode={id} />
              </Box>
            )}
          </Box>
          <Card sx={{ padding: '10px 20px 20px' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', marginTop: '10px' }}>
                  <Typography variant="h6" width="170px">
                    Tipo de envio:
                  </Typography>
                  <Typography>{tipoPaq}</Typography>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '10px' }}>
                  <Typography variant="h6" width="170px">
                    Empaquetado:
                  </Typography>
                  <Typography>{envioDetalle.empaquetado ? 'Si' : 'No'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '10px' }}>
                  <Typography variant="h6" width="170px">
                    Precio:
                  </Typography>
                  <Typography>{fCurrency(envioDetalle.shippingValue)}</Typography>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '10px' }}>
                  <Typography variant="h6" width="170px">
                    Seguro:
                  </Typography>
                  <Typography>
                    {envioDetalle.seguro === 'asegurado' ? fCurrency(envioDetalle.declared_value) : 'No Asegurado'}
                  </Typography>
                </Box>
                {envioDetalle.empaquetado && (
                  <>
                    <Box sx={{ display: 'flex', marginTop: '10px' }}>
                      <Typography variant="h6" width="170px">
                        Empaq. precio:
                      </Typography>
                      <Typography>{fCurrency(envioDetalle.empaquetadoValue)}</Typography>
                    </Box>

                    <Box sx={{ display: 'flex', marginTop: '10px' }}>
                      <Typography variant="h6" width="180px">
                        Empaq. Items:
                      </Typography>
                      <Tabla empaquetados={envioDetalle?.empaquetadoDetalle?.items} />
                    </Box>
                  </>
                )}

                <Box sx={{ display: 'flex', marginTop: '10px' }}>
                  <Typography variant="h6" width="170px">
                    Con descuento:
                  </Typography>
                  <Typography>
                    {envioDetalle.descuentoCorporativo || envioDetalle.descuentoIncremento ? 'Si' : 'No'}
                  </Typography>
                </Box>

                {envioDetalle.descuentoCorporativo && (
                  <>
                    <Box sx={{ display: 'flex', marginTop: '10px' }}>
                      <Typography variant="h6" width="170px">
                        Descuento:
                      </Typography>
                      <Typography>
                        {fCurrency(envioDetalle.descuentoIncrementoCorpoValue || envioDetalle.descuentoIncremento)}
                      </Typography>
                    </Box>
                  </>
                )}

                {tipoPaq === 'paquete' && (
                  <Box sx={{ display: 'flex', marginTop: '10px' }}>
                    <Typography variant="h6" width="180px">
                      Datos del Paquete:
                    </Typography>
                    <SimpleTable data={paquete_data} />
                  </Box>
                )}
                {/* <Box sx={{ display: 'flex', marginTop: '10px' }}>
                  <Typography variant="h6" width="170px">
                    Total:
                  </Typography>
                  <Typography>{fCurrency(envioDetalle.shippingValue)}</Typography>
                </Box> */}
                <Box sx={{ display: 'flex', marginTop: '10px' }}>
                  <Typography variant="h6" width="170px">
                    Estado:
                  </Typography>
                  <Chip label={envioDetalle.state} size="small" color="info" />
                </Box>
                {envioDetalle.state === 'PAGADO' ? (
                  <>
                    <Box sx={{ display: 'flex', marginTop: '10px' }}>
                      <Typography variant="h6" width="170px">
                        Metodo de pago:
                      </Typography>
                      <Typography>{envioDetalle.payment_method}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', marginTop: '10px' }}>
                      <Typography variant="h6" width="170px">
                        Medio de pago:
                      </Typography>
                      <Typography>{envioDetalle.payment_source}</Typography>
                    </Box>

                    <Box sx={{ display: 'flex', marginTop: '10px' }}>
                      <Typography variant="h6" width="170px">
                        Guia:
                      </Typography>
                      {!errorGuia && (
                        <LoadingButton
                          loading={loadingGuia}
                          variant="contained"
                          endIcon={<Icon icon="eva:file-text-fill" />}
                        >
                          <a
                            style={{ color: 'inherit', textDecoration: 'none' }}
                            target="_blank"
                            rel="noreFerrer"
                            href={urlGuia}
                          >
                            Descargar PDF
                          </a>
                        </LoadingButton>
                      )}
                      {errorGuia && <Typography>La guía no se cargó correctamente</Typography>}
                    </Box>
                  </>
                ) : null}
                {envioDetalle.state === 'PAGADO' && envioDetalle.tipo_destino === 'internacional' && (
                  <Box sx={{ display: 'flex', marginTop: '15px' }}>
                    <Typography variant="h6" width="170px">
                      Fact. comercial:
                    </Typography>

                    <Button variant="contained" endIcon={<Icon icon="eva:file-text-fill" />}>
                      <a
                        style={{ color: 'inherit', textDecoration: 'none' }}
                        target="_blank"
                        rel="noreFerrer"
                        href="/docs/factura_comercial.pdf"
                      >
                        Descargar PDF
                      </a>
                    </Button>
                  </Box>
                )}
                {/* <BtnImprimirGuia urlGuia={urlGuia} /> */}
                {envioDetalle.state === 'PAGADO' && (
                  <Box sx={{ display: 'flex', marginTop: '15px' }}>
                    <Typography variant="h6" width="170px">
                      Recibo:
                    </Typography>

                    <BlobProvider document={<ReciboEnvio data={envioDetalle} idQr={id} />}>
                      {({ url }) => {
                        console.log(url);
                        return (
                          <Button variant="contained" href={url} target="_blank" rel="noreferrer">
                            Recibo
                          </Button>
                        );
                      }}
                    </BlobProvider>

                    {/* <Button variant="contained" endIcon={<Icon icon="eva:file-text-fill" />}>
                      <PDFDownloadLink
                        style={{ textDecoration: 'none', color: '#fff' }}
                        document={<ReciboEnvio data={envioDetalle} />}
                        fileName={`recibo-${envioDetalle.object_id}.pdf`}
                      >
                        Descargar PDF
                      </PDFDownloadLink>
                    </Button> */}
                  </Box>
                )}

                {/* <Box width="300px">
                  <PDFViewer showToolbar>
                    <ReciboEnvio data={envioDetalle} />
                  </PDFViewer>
                </Box> */}
              </Grid>
              <Grid item xs={12} md={6}>
                {/* <PaqueteriaCard item={paqueteriaData} pointer={0} /> */}
                {envioDetalle.state === 'PAGADO' &&
                  (currentUser?.contratoLicenciatario === contratosList.tradicional.id ||
                    !currentUser?.contratoLicenciatario) && (
                    <Box sx={{ marginTop: '30px' }}>
                      <DialogFacturar envioDetalle={envioDetalle} />
                    </Box>
                  )}
                {envioDetalle.state === 'PAGADO' && (
                  <Box sx={{ marginTop: '30px' }}>
                    <DialogSolCancelarEnv data={envioDetalle} />
                  </Box>
                )}
                {envioDetalle.state === 'PENDIENTE-PAGO' &&
                  (currentUser.id === envioDetalle.user_id || currentUser.role === 'almighty') && (
                    <Box sx={{ marginTop: '30px' }}>
                      <AddToCartBtn data={envioDetalle} />
                    </Box>
                  )}
                {envioDetalle.state === 'PENDIENTE-PAGO' && (
                  <Box>
                    <BlobProvider document={<ReciboCotizacion data={envioDetalle} />}>
                      {({ url }) => {
                        console.log(url);
                        return (
                          <Button
                            sx={{ marginY: 2 }}
                            // loading={loadingGuia}
                            variant="contained"
                            endIcon={<Icon icon="material-symbols:print" />}
                            href={url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Imprimir cotización
                          </Button>
                        );
                      }}
                    </BlobProvider>
                  </Box>
                )}

                {envioDetalle?.purchased_guia === 'PENDING' && provider[0] === 'SuperEnvios' && (
                  <Box sx={{ marginTop: '30px' }}>
                    <BtnActualizarEnvio idEnvio={envioDetalle?.object_id} />
                  </Box>
                )}
              </Grid>
              <Grid item xs={12}>
                <DetalletEnvio data={envioDetalle} />
              </Grid>

              {/* ======== tabla rastreo */}
              <Grid item xs={12}>
                <Typography textAlign="center" variant="subtitle1" fontSize="20px">
                  Rastreo
                </Typography>
                {provider[0] !== 'DHL' && (
                  <TablaRastreo
                    rate_provider={queryParams.get('paqueteria')}
                    trackingNumber={
                      queryParams.get('tracking_code') !== 'undefined'
                        ? queryParams.get('tracking_code')
                        : queryParams.get('codigo')
                    }
                  />
                )}
                {provider[0] === 'DHL' && (
                  <TablaRastreo
                    rate_provider={queryParams.get('paqueteria')}
                    trackingNumber={
                      queryParams.get('tracking_code') !== 'undefined'
                        ? queryParams.get('codigo')
                        : queryParams.get('tracking_code')
                    }
                  />
                )}
              </Grid>
            </Grid>

            {/* <TableContainer component={Paper} sx={{ marginTop: '20px' }}>
              <Title title="Eventos" />
              <Tabla eventos={eventos} />
            </TableContainer> */}
          </Card>
        </Container>
      )}
    </Page>
  );
}

export default PaqDetalleEnvio;

function Tabla({ empaquetados }) {
  // const { area, date, description } = eventos;
  return (
    <Table aria-label="simple table">
      <TableHead>
        <TableRow>
          <TableCell>Nombre</TableCell>
          <TableCell>Precio</TableCell>
          <TableCell>Cantidad</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {empaquetados?.map((item, id) => (
          <TableRow key={id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell component="th" scope="row">
              {item.name}
            </TableCell>
            <TableCell>{fCurrency(item.precio)}</TableCell>
            <TableCell>
              {item.cantidad} {item.type === 'caja' ? 'Unid.' : 'Met.'}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
